import repository from '@/repositories/Repository'

const resource = '/stores'

export default {
  get(storeGroup) {
    return repository.bizoo
      .get(`${resource}/${storeGroup}?all=false`)
      .then(r => r.data)
  },
}
